<template>
  <VueSlickCarousel v-bind="settings">
    <div class="main-banner-item">
      <img :src="imagePath" class="img-fluid" alt="banner" />
    </div>
    <div class="main-banner-item">
      <img :src="imagePath" class="img-fluid" alt="banner" />
    </div>
    <div class="main-banner-item">
      <img :src="imagePath" class="img-fluid" alt="banner" />
    </div>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  props: {
    imagePath: "",
  },
  data() {
    return {
      settings: {
        speed: 500,
        arrows: false,
        centerMode: true,
        centerPadding: '16px',
        infinite: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  },
  components: {
    VueSlickCarousel
  }
}
</script>